import { createContext, useContext, useState, ReactNode } from 'react';
import { Episode } from '../types/podcast';

interface PlayerContextType {
    currentEpisode: Episode | null;
    isPlaying: boolean;
    playEpisode: (episode: Episode) => void;
    togglePlay: () => void;
    closePlayer: () => void;
    setIsPlaying: (isPlaying: boolean) => void;
}

const PlayerContext = createContext<PlayerContextType | undefined>(undefined);

export const PlayerProvider = ({ children }: { children: ReactNode }) => {
    const [currentEpisode, setCurrentEpisode] = useState<Episode | null>(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const playEpisode = (episode: Episode) => {
        if (currentEpisode?.id === episode.id) {
            togglePlay();
        } else {
            setCurrentEpisode(episode);
            setIsPlaying(true);
        }
    };

    const togglePlay = () => {
        setIsPlaying((prev) => !prev);
    };

    const closePlayer = () => {
        setIsPlaying(false);
        setCurrentEpisode(null);
    };

    return (
        <PlayerContext.Provider value={{ currentEpisode, isPlaying, playEpisode, togglePlay, closePlayer, setIsPlaying }}>
            {children}
        </PlayerContext.Provider>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export const usePlayer = () => {
    const context = useContext(PlayerContext);
    if (!context) {
        throw new Error('usePlayer must be used within a PlayerProvider');
    }
    return context;
};
